import { GetBodyCustomerImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImageTabsAlerts/getBodyCustomerImageTabsAlertsQuery.type';
import { getBodyCustomerImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCustomerImageTabsAlerts/getBodyCustomerImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getBodyCustomerImageTabsAlertsQueryOptions = (
  params: GetBodyCustomerImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_BODY_CUSTOMER_IMAGE_TABS_ALERTS', params],
    queryFn: () => getBodyCustomerImageTabsAlertsQueryFunctions(params),
  });
export default getBodyCustomerImageTabsAlertsQueryOptions;
